import S from '../../Recruitment/RecruitmentEnd/RecruitmentEnd.module.scss';
import RecruitmentEndDetail from '../../../common/RecruitmentCardEnd/index';

import { useNavigate, useParams } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import PopupModal from '../../../common/PopupModal';
import { RecruitmentDetailType } from '../../../../types/RecruitmentTypes';
import { AuthUtils } from '../../../../utils/AuthUtils';
import { IvyUserInfoService } from '../../../../service/IvyUserInfoService';
import { fetchRecruitmentDetail } from '../../../../repository/RecruitmentRepository';

/* 구인 엔드 */
const RecruitmentEnd = () => {
  IvyUserInfoService();

  const { id } = useParams<string>();
  const navigate = useNavigate();
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);
  const token = AuthUtils.getCookie('token');
  const [content, setContent] = useState<RecruitmentDetailType>({} as RecruitmentDetailType);

  const getRecruitmentDetail = (id: number) => {
    fetchRecruitmentDetail(id, token)
      .then((res) => {
        if (res && res.id > 0) {
          setContent(res);
        } else {
          setIsOpenModal(true);
        }
      })
      .catch((e) => console.error(e));
  };

  useEffect(() => {
    if (id && !isNaN(Number(id))) {
      getRecruitmentDetail(Number(id));
    } else {
      setIsOpenModal(true);
    }
  }, [id]);

  if (id === undefined) {
    return null;
  }

  return (
    <>
      <PopupModal
        isOpenModal={isOpenModal}
        setIsOpenModal={setIsOpenModal}
        needsCancelBtn={false}
        message={'잘못된 링크입니다.'}
        confirmFn={() => navigate('/')}
      />
      <main className={`${S.recruitment_end_container} wrapper`}>
        {/* 구인 엔드 채용 상세 */}
        <RecruitmentEndDetail id={id} content={content} />
      </main>
    </>
  );
};

export default RecruitmentEnd;
